import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { createRef, useState } from 'react';
import { trackAccordionExpanded } from "./tracking";
import * as styles from "./Accordion.styles";
export var Accordion = function Accordion(_ref) {
  var bodyTestId = _ref.bodyTestId,
    children = _ref.children,
    heading = _ref.heading;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var headingRef = /*#__PURE__*/createRef();
  var toggleExpanded = function toggleExpanded() {
    if (isOpen) {
      setIsOpen(false);
    } else {
      var _headingRef$current;
      trackAccordionExpanded(((_headingRef$current = headingRef.current) === null || _headingRef$current === void 0 ? void 0 : _headingRef$current.textContent) || '');
      setIsOpen(true);
    }
  };
  var handleKeyPress = function handleKeyPress(e) {
    var keyCode = e.key;
    if (['Enter', ' ', 'Spacebar'].includes(keyCode)) {
      e.preventDefault();
      toggleExpanded();
    }
  };
  var withExtraProps = function withExtraProps(element) {
    return /*#__PURE__*/React.cloneElement(element, {
      isOpen
    });
  };
  return /*#__PURE__*/React.createElement(_StyledDetails, {
    $_css: styles.accordionItem
  }, /*#__PURE__*/React.createElement(_StyledSummary, {
    "aria-expanded": isOpen,
    onClick: toggleExpanded,
    onKeyDown: handleKeyPress,
    ref: headingRef,
    $_css2: styles.accordionHeading
  }, withExtraProps(heading)), /*#__PURE__*/React.createElement("div", {
    "data-testid": bodyTestId,
    role: isOpen ? 'region' : '',
    style: {
      display: isOpen ? 'block' : 'none'
    }
  }, children));
};
var _StyledDetails = _styled("details")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSummary = /*#__PURE__*/_styled2("summary").withConfig({
  displayName: "Accordion___StyledSummary",
  componentId: "sc-10d9vpi-0"
})(["", ""], function (p) {
  return p.$_css2;
});